import dataLayer from "./index";
import {ITEM_TYPE_ITEM} from "../../constants";
import * as Constants from "../../constants";
import {clone, isEmpty} from "lodash";
import {round} from "@popperjs/core/lib/utils/math";

class InvoiceItem {
  /**
   * @enum {"app\\models\\Item"|"app\\models\\BookRecordAnimal"|"app\\models\\GroupHuntingAnimal"|"app\\models\\CollectiveHuntingAnimal"} type
   */
  type = null;
  id = null;
  no = null;

  price_1_class = null;
  price_2_class = null;
  price_beyond = null;
  flat_rate = null;
  price_type = null;

  price_brutto = null;
  price_netto = null;

  quality = null;
  invoice_item_id = null;
  quantity = null;
  vat = null;
  unit = null;
  uuid = null;
  currency = null;

  update_prices = false

  isAfterCorrection = false

  snapshot = null
  parent = null

  constructor(itemOrAnimal) {
    this.type = itemOrAnimal.type ?? ITEM_TYPE_ITEM;
    this.id = itemOrAnimal.id;
    this.no = itemOrAnimal.no;

    this.price_1_class = itemOrAnimal.current_price_1_class ?? itemOrAnimal.price_1_class;
    this.price_2_class = itemOrAnimal.current_price_2_class ?? itemOrAnimal.price_2_class;
    this.price_beyond = itemOrAnimal.current_price_beyond ?? itemOrAnimal.price_beyond;
    this.flat_rate = itemOrAnimal.current_flat_rate ?? itemOrAnimal.flat_rate;
    this.price_type = itemOrAnimal.price_type ?? null;
    this.price_netto = itemOrAnimal.price_netto ?? null;
    this.price_brutto = itemOrAnimal.price_brutto ?? null;
    this.quality = itemOrAnimal.quality ?? null;
    this.invoice_item_id = itemOrAnimal.invoice_item_id ?? null;
    this.uuid = itemOrAnimal.uuid ?? null;
    this.currency = itemOrAnimal.currency ?? null;

    this.quantity = itemOrAnimal.quantity;
    this.unit = this.isAnimal ? null : itemOrAnimal.unit;
    this.vat = this.isAnimal ? null : itemOrAnimal.vat;
    this.weight = this.isAnimal ? itemOrAnimal.weight : null;

    this.snapshot = clone(this)
    this.parent = !isEmpty(itemOrAnimal.parent) ? new InvoiceItem(itemOrAnimal.parent) : null
  }

  get isAnimal() {
    return this.type !== ITEM_TYPE_ITEM;
  }

  get details() {
    if (this.type === "app\\models\\Item") {
      return dataLayer.state.items.find(i => i.id === this.id);
    }

    return dataLayer.state.animals.find(a => a.id === this.id && a.type === this.type);
  }

  get name() {
    if (this.isAnimal) {
      if (this.details.identifier && this.details.identifier.length > 0) {
        return this.details.name + ` (${this.details.identifier})`;
      }
    }

    return this.details.name;
  }

  get editing() {
    return this.invoice_item_id !== null;
  }

  get uniqueId() {
    if (this.isAnimal) {
      return `${this.type}-${this.id}`
    }

    return `${this.type}-${this.uuid}`
  }

  get isStored() {
    return typeof this.invoice_item_id != 'undefined' && this.invoice_item_id !== null;
  }

  hasChanged(priceListType, intendedUse, key = null) {
    let changed = false;

    if (key === 'quantity' || key === null) {
      if (this.isAnimal && this.getQuantity(priceListType) !== this.getOriginalQuantity(priceListType)) {
        changed = true
      }
    }

    if (key === 'unit' || key === null) {
      if (!this.isAnimal && this.getUnit(priceListType) !== this.details.unit) {
        changed = true
      }
    }

    if (key === 'vat' || key === null) {
      if (!this.isAnimal && this.vat !== this.details.vat) {
        changed = true
      }
    }

    if (key === 'price' || key === null) {
      if (parseFloat(this.getPrice(intendedUse, priceListType)) !== parseFloat(this.getOriginalPrice(intendedUse, priceListType))) {
        changed = true
      }
    }

    if (key === 'currency' || key === null) {
      if (!this.isAnimal && this.currency !== this.details.currency) {
        changed = true
      }
    }

    return changed
  }

  getVat(form) {
    if (this.isAnimal) {
      let vat = parseFloat($(form).find('[name="vat"]').val());
      if(isNaN(vat)) {
        vat = 0;
      }

      return vat
    }

    if (this.vat !== null) {
      return this.vat;
    }

    return this.details.vat;
  }

  getUnit(priceListType) {
    if (this.isAnimal) {
      if (parseInt(priceListType) === Constants.PRICE_LIST_REGULAR) {
        return 'kg';
      }

      return 'szt';
    }

    if (this.invoice_item_id) {
      return this.unit;
    }

    return this.details.unit;
  }

  getOriginalQuantity(priceListType) {
    if (this.isAnimal) {
      if (parseInt(priceListType) === Constants.PRICE_LIST_REGULAR) {

        if(this.details.weight == 0 || this.details.weight == null ){
          this.details.weight = 1;
        }

        return parseFloat(this.details.quantity) * parseFloat(this.details.weight);
      }

      return parseFloat(this.details.quantity);
    }

    return null;
  }

  getQuantity(priceListType) {
    if (this.isAnimal) {
      if (!this.invoice_item_id) {
        if(this.weight == 0 || this.weight == null ){
          this.weight = 1;
        }
        return this.getOriginalQuantity(priceListType)
      }

      if (parseInt(priceListType) === Constants.PRICE_LIST_REGULAR) {

        if(this.weight == 0 || this.weight == null ){
          this.weight = 1;
        }
        return parseFloat(this.quantity) * parseFloat(this.weight);
      }

      return parseFloat(this.quantity);
    }

    return this.quantity;
  }

  getPrices(intendedUse) {
    const originalPrices = this.getOriginalPrices(intendedUse)

    return {
      price_1_class: this.price_1_class ?? originalPrices.price_1_class,
      price_2_class: this.price_2_class ?? originalPrices.price_2_class,
      price_beyond: this.price_beyond ?? originalPrices.price_beyond,
      flat_rate: this.flat_rate ?? originalPrices.flat_rate
    }
  }

  getOriginalPrices(intendedUse) {
    if (!this.isAnimal) {
      if(this.price_type == 2){
        return {
          price_1_class: this.getBruttoForItems(),
          price_2_class: this.getBruttoForItems(),
          price_beyond: this.getBruttoForItems(),
          flat_rate: this.getBruttoForItems()
        }
      }
      return {
        price_1_class: this.getNettoForItems(),
        price_2_class: this.getNettoForItems(),
        price_beyond: this.getNettoForItems(),
        flat_rate: this.getNettoForItems()
      }
    }

    if (parseInt(intendedUse) === 1) {
      let collectionCentre = dataLayer.state.collectionCentres.find(c => parseInt(c.id) === parseInt(this.details.collection_centre_id));

      if (!collectionCentre) {
        return {price_1_class: null, price_2_class: null, price_beyond: null, flat_rate: null};
      }

      const prices = collectionCentre.cc_prices.find(p => parseInt(p.animal_type_id) === parseInt(this.details.animal_type_id));
      const animalPrices = prices?.animal_cc_prices.find(p => parseInt(p.animal_id) === parseInt(this.details.animal_id));

      return {
        price_1_class: animalPrices?.price_1_class ?? prices?.price_1_class ?? null,
        price_2_class: animalPrices?.price_2_class ?? prices?.price_2_class ?? null,
        price_beyond: animalPrices?.price_beyond ?? prices?.price_beyond ?? null,
        flat_rate: animalPrices?.flat_rate ?? prices?.flat_rate ?? null
      }
    }

    if (dataLayer.currentEntity !== null) {
      const prices = dataLayer.currentEntity.be_prices.find(el => parseInt(el.animal_type_id) === parseInt(this.details.animal_type_id));
      const animalPrices = prices?.animal_be_prices.find(el => parseInt(el.animal_id) === parseInt(this.details.animal_id));

      return {
        price_1_class: animalPrices?.price_1_class ?? prices?.price_1_class ?? null,
        price_2_class: animalPrices?.price_2_class ?? prices?.price_2_class ?? null,
        price_beyond: animalPrices?.price_beyond ?? prices?.price_beyond ?? null,
        flat_rate: animalPrices?.flat_rate ?? prices?.flat_rate ?? null
      }
    }

    return {
      price_1_class: this.details.ex_price_1_class ?? this.details.price_1_class,
      price_2_class: this.details.ex_price_2_class ?? this.details.price_2_class,
      price_beyond: this.details.ex_price_beyond ?? this.details.price_beyond,
      flat_rate: this.details.ex_flat_rate ?? this.details.flat_rate
    }
  }

  getOriginalPrice(intendedUse, priceListType) {
    const originalPrices = this.getOriginalPrices(intendedUse)

    if (this.isAnimal && parseInt(priceListType) === Constants.PRICE_LIST_REGULAR) {
      switch (parseInt(this.quality)) {
        case 1:
          return originalPrices.price_1_class;
        case 2:
          return originalPrices.price_2_class;
      }

      return originalPrices.price_beyond;
    }

    return originalPrices.flat_rate;
  }

  getPrice(intendedUse, priceListType) {
    const prices = this.getPrices(intendedUse);

    if (this.isAnimal && parseInt(priceListType) === Constants.PRICE_LIST_REGULAR) {
      switch (parseInt(this.quality)) {
        case 1:
          return prices.price_1_class;
        case 2:
          return prices.price_2_class;
      }

      return prices.price_beyond;
    }

    return prices.flat_rate;
  }

  getCurrency() {
    if (this.isAnimal) {
      return parseInt(defaultCurrency) === 2 ? 'EUR' : 'PLN';
    }

    return parseInt(this.currency ?? this.details.currency) === 2 ? 'EUR' : 'PLN';
  }

  getOriginalCurrency() {
    if (this.isAnimal) {
      return parseInt(defaultCurrency) === 2 ? 'EUR' : 'PLN';
    }

    return parseInt(this.details.currency) === 2 ? 'EUR' : 'PLN';
  }

  getNettoForItems() {
    // console.log(this.details);
    // if(parseInt(this.details.price_type) === 1){
    //   return this.details.price_netto;
    // }
    // return this.details.price_brutto;

    // const netto = this.details.price / (this.vat * 0.01 + 1);
    // return netto.toFixed(2);

    return this.details.price_netto;
  }

  getBruttoForItems() {
    return this.details.price_brutto;
  }

  calculateBruttoForItems() {
    const brutto = this.getPrice() / (this.vat * 0.01 + 1);
    return brutto.toFixed(2);
  }

  resetPrices(intendedUse) {
    const original = this.getOriginalPrices(intendedUse)

    this.price_1_class = original.price_1_class
    this.price_2_class = original.price_2_class
    this.price_beyond = original.price_beyond
    this.flat_rate = original.flat_rate
  }

  autoSetQualityChosen(intendedUse) {
    if (!this.isAnimal) {
      return
    }

    const prices = this.getPrices(intendedUse)

    if (this.quality === null) {
      if (prices.price_1_class) {
        this.quality = 1
      } else if (prices.price_2_class) {
        this.quality = 2
      } else if (prices.price_beyond) {
        this.quality = 0
      }
    }
  }

  fitsRequirements(intendedUse, priceListType) {
    if (!this.isAnimal) {
      return true;
    }

    const prices = this.getPrices(intendedUse)

    if (parseInt(priceListType) === Constants.PRICE_LIST_REGULAR) {
      if (parseFloat(this.details.weight) === 0 || !this.details.weight) {
        return false
      }

      if (!prices.price_1_class && !prices.price_2_class && !prices.price_beyond) {
        return false;
      }
    } else if (parseInt(priceListType) === Constants.PRICE_LIST_FLAT_RATE) {
      if (!prices.flat_rate) {
        return false;
      }
    }

    return true;
  }
}

export default InvoiceItem